module.exports = __webpack_public_path__ + "img/欧洲专利.7c4e05a3.png";